import { Button } from '@app/components/various/Button';
import { useDropdownContext } from '@app/components/various/Dropdown/context/DropdownContext';
import { Search } from '@app/components/various/Search';
import { useAmplitude } from '@app/utils/analytics/useAmplitude';
import { useModalVisibility } from '@app/utils/hooks';
import { Key } from '@app/utils/keys';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { OrderSelectMenu } from './OrderSelectMenu';

export const OrderSelectPopover = () => {
  const { t } = useTranslation(['common', 'selections']);

  const [search, setSearch] = React.useState('');

  const { isDropdownOpen, closeDropdown, menuId } = useDropdownContext();
  const { showModal: showCreateSelectionModal } = useModalVisibility('CreateOrderModal');
  const { trackEvent } = useAmplitude();

  const searchRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (isDropdownOpen) {
      searchRef.current?.focus();
    }
  }, [isDropdownOpen]);

  const handleCreateSelectionClick = () => {
    closeDropdown();
    showCreateSelectionModal();
    trackEvent({ name: 'bottomBar.button.createselection.click' });
  };

  const handleTabKey = (event: React.KeyboardEvent) => {
    if (!event.shiftKey) {
      closeDropdown();
    }
  };

  const handleSearchKeyDown = (event: React.KeyboardEvent) => {
    if (event.shiftKey && event.code === Key.TAB) {
      closeDropdown();
    }
  };

  return (
    <>
      <div className="grid grid-cols-[1fr,auto] gap-3 bg-white p-3 pb-2">
        <Search
          ref={searchRef}
          size="regular"
          isFluid
          placeholder={t('selections:search_selection')}
          onKeyDown={handleSearchKeyDown}
          onChange={setSearch}
        />
        <Button size="medium" onClick={handleCreateSelectionClick}>
          {t('selections:create_selection')}
        </Button>
      </div>
      <div id={menuId} className="overflow-auto p-3 pt-1">
        <OrderSelectMenu search={search} onTab={handleTabKey} onOptionClick={closeDropdown} />
      </div>
    </>
  );
};
